import { LeadStatus } from '@inpart-io/padme-iap';

export interface LeadStatusOption {
    key: string;
    label: string;
    values: Array<LeadStatus | LeadStatusSet>;
    count: number;
}

export enum LeadStatusSet {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    CLOSED = 'Closed'
}

export const LeadOnlyStatusSetValues = new Map<LeadStatusSet, LeadStatus[]>([
    [LeadStatusSet.ACTIVE, [LeadStatus.DRAFT, LeadStatus.TRIAGE]],
    [LeadStatusSet.INACTIVE, [LeadStatus.ON_HOLD, LeadStatus.DISQUALIFIED]],
    [LeadStatusSet.CLOSED, [LeadStatus.QUALIFIED]]
]);

export const StatusSetValues = new Map<LeadStatusSet, LeadStatus[]>([
    [LeadStatusSet.ACTIVE, [LeadStatus.DRAFT, LeadStatus.TRIAGE, LeadStatus.DEAL]],
    [LeadStatusSet.INACTIVE, [LeadStatus.ON_HOLD, LeadStatus.DISQUALIFIED]],
    [LeadStatusSet.CLOSED, [LeadStatus.CLOSED, LeadStatus.QUALIFIED]]
]);

export const LeadOnlyNextStatus = new Map<LeadStatus, Array<LeadStatus | LeadStatusSet>>([
    [LeadStatus.DRAFT, [LeadStatus.DISQUALIFIED]],
    [LeadStatus.TRIAGE, [LeadStatus.ON_HOLD, LeadStatus.DISQUALIFIED]],
    [LeadStatus.QUALIFIED, [LeadStatusSet.ACTIVE]],
    [LeadStatus.DISQUALIFIED, [LeadStatusSet.ACTIVE]],
    [LeadStatus.ON_HOLD, [LeadStatusSet.ACTIVE, LeadStatus.DISQUALIFIED]]
]);

export const NextStatus = new Map<LeadStatus, Array<LeadStatus | LeadStatusSet>>([
    [LeadStatus.DRAFT, [LeadStatus.DISQUALIFIED]],
    [LeadStatus.TRIAGE, [LeadStatus.ON_HOLD, LeadStatus.DISQUALIFIED]],
    [LeadStatus.DISQUALIFIED, [LeadStatusSet.ACTIVE]],
    [LeadStatus.ON_HOLD, [LeadStatusSet.ACTIVE, LeadStatus.DISQUALIFIED]],
    [LeadStatus.DEAL, [LeadStatus.ON_HOLD, LeadStatus.DISQUALIFIED]],
    [LeadStatus.CLOSED, [LeadStatusSet.ACTIVE]],
    [LeadStatus.QUALIFIED, [LeadStatusSet.ACTIVE]]
]);
